define(
    "diy/undo-redo/plugins/Base",
    function () {
        'use strict';
        var
            Plugin,
            readyState = {
                READY: 1,
                REGISTERED: 2,
                ENABLED: 3,
                OFFLINE: 4
            };
        /**
         * @class module.undoRedo.plugins.Base
         * @template module.undoRedo.plugins.Base
         * @lends {module.undoRedo.plugins.Base.prototype}
         * @constructor
         */
        Plugin = Klazz.extend({
            readyState: undefined,
            /**
             * @type {module.undoRedo.Api}
             */
            api: undefined,

            /**
             *
             * @param {module.undoRedo.Api} api
             */
            initialize: function (api) {
                this.readyState = readyState.OFFLINE;
                this.api = api;
            },

            /**
             *
             * @returns {boolean}
             */
            isRegistered: function () {
                return this.readyState === readyState.REGISTERED;
            },
            /**
             * sets registered state
             */
            markAsRegistered: function () {
                this.readyState = readyState.REGISTERED;
            },
            /**
             *
             * @returns {boolean}
             */
            isEnabled: function () {
                return this.readyState === readyState.ENABLED;
            },
            /**
             * sets registered state
             */
            markAsEnabled: function () {
                this.readyState = readyState.ENABLED;
            },

            /**
             *
             * @returns {boolean}
             */
            isReady: function () {
                return this.readyState === readyState.READY;
            },
            /**
             * sets ready state
             */
            markAsReady: function () {
                this.readyState = readyState.READY;
            },
            /**
             * will run when api is ready
             *
             */
            onInit: function () {
                this.markAsReady();
            },

            /**
             *
             * @returns {String}
             */
            getType: function getType() {
                return '';
            },
            /**
             *
             * @param {module.undoRedo.HistoryEntry.Base} entry
             */
            onSelect: function onSelect(entry) {

            },
            /**
             *
             * @param {module.undoRedo.HistoryEntry.Base} entry
             */
            onDeselect: function onDeselect(entry) {

            },
            /**
             *
             * @param {module.undoRedo.App} app
             */
            onReady: function (app) {
                
            }
        });

        return Plugin;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/plugins/Base.js
 ** module id = 892
 ** module chunks = 0
 **/